import React, { Component } from 'react';
import MainAuthView from './MainAuthView';

class MainAuthComponent extends Component {
    state = {
        seconds: 11,
        securityCode: '',
        timeLeft: '',
        modal_show: false,
    }

    hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }
        calculateTimeLeft = () => {
        let year = new Date().getFullYear();
        console.log('Date()',Date())
        let difference = +new Date(`11/01/${year}`) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
          timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60)
        };
        this.setState({timeLeft: timeLeft})
        console.log('timeleft',this.state.timeLeft)
      }
    }
    componentDidMount() {
        const timer = setInterval(() => {
        this.calculateTimeLeft()
      }, 1000);

    }

    
    handelValue = (data) =>{
        console.log('data',data)
        
            this.setState({securityCode: data})
        
    }

    handelSummit = () =>{
        console.log('sadas',this.state.securityCode)
        if (this.state.securityCode === '930930'){
            console.log('sadas',this.state.securityCode)
        localStorage.removeItem('token')
        localStorage.removeItem('refresh')
        localStorage.removeItem('is_applicant')
        localStorage.removeItem('is_admin')
        localStorage.removeItem('is_candidate')
        localStorage.removeItem('is_pre_screen_applicant')
        localStorage.removeItem('flow')
        sessionStorage.setItem('securityCode',this.state.securityCode)
        window.location.href = '/login';
        }
    }
    joinourteam = () =>{
        localStorage.setItem('flow', 'join_our_team')
        window.location.href = '/login'

    }
   
    render() {
        return (
            <MainAuthView
            modal_show = {this.state.modal_show}
			hideCustomModal = {this.hideCustomModal}
            timeleft={this.state.timeLeft}
            seconds={this.state.seconds}
            handelSummit={this.handelSummit}
            handelValue={this.handelValue}
            showCustomModal={this.showCustomModal}
            joinourteam={this.joinourteam}
            />
        )
    }
}

export default MainAuthComponent;